import ReactModal from "react-modal";
import TierList from "../components/tierList";
import { useCallback, useState } from "react";
import { videoGameList } from "../../lists/videoGameLists";

export default function VideoGames() {

    const [showModal, setShowModal] = useState(false);
    const handleOpenModal = useCallback((index) => {
        setShowModal(true);
    }, []);
    const handleCloseModal = useCallback((index) => {
        setShowModal(false);
    }, []);

    return (
        <>

            <div className="gaming-tier-list-button" onClick={handleOpenModal}>
                <img
                    src={process.env.PUBLIC_URL + "/images/home/videoGame.png"}
                    className="gaming-card-icon"
                    alt="videoGameIcon"
                />
                <div className="index-card-header">Video Game Tier List</div>
            </div>

            <div className="mt-5 col-12 col-md-4">
                <ReactModal
                    isOpen={showModal}
                    contentLabel="Minimal Modal Example"
                >
                    <TierList
                        items={videoGameList}
                    />
                    <button onClick={handleCloseModal}>Close Window</button>
                </ReactModal>
            </div>
        </>
    )
}
